import './style.scss'

{
	document.querySelectorAll( '.wp-block-mantenia-accordion' ).forEach( function ( block ) {
		const collapseItem = function ( heading ) {
			const content = heading.nextElementSibling;
			if ( ! content ) {
				return;
			}
			content.style.maxHeight = content.scrollHeight + "px";
			setTimeout( function () {
				heading.ariaExpanded = 'false';
				content.style.maxHeight = null;
			}, 10 );
		};

		const expandItem = function ( heading, scrollIntoView = false ) {
			block.querySelectorAll( '.wp-block-mantenia-accordion-title[aria-expanded=true]' ).forEach( collapseItem );
			const content = heading.nextElementSibling;
			if ( ! content ) {
				return;
			}
			content.style.maxHeight = content.scrollHeight + "px";
			setTimeout( function () {
				heading.ariaExpanded = 'true';
				content.addEventListener( 'transitionend', function () {
					content.style.maxHeight = null;
				} );
				if ( scrollIntoView ) {
					heading.scrollIntoView( { block: 'start', inline: 'nearest' } );
				}
			}, 10 );
		};

		block.querySelectorAll( '.wp-block-mantenia-accordion-title' ).forEach( function ( heading ) {
			heading.addEventListener( 'click', function ( ev ) {
				ev.preventDefault();
				if ( heading.ariaExpanded === 'true' ) {
					collapseItem( heading );
				} else {
					expandItem( heading );
				}
			} );
		} );

		const hash = window.location.hash;
		if ( hash !== "" ) {
			const heading = block.querySelector( '.wp-block-mantenia-accordion-item' + hash + ' .wp-block-mantenia-accordion-title' );
			if ( heading ) {
				expandItem( heading, true );
			}
		}
	} );
}
